import timeFormAPI from '../../api/ui/timeFormAPI';
import {create} from './table-schema';
import useTranslation from '../../hooks/useTranslation';
import {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import changeNumApi from "../../api/ui/changeNumApi";
import {convertBigNumToDecimalString} from "../../utils/convert-decimal-to-big-num";
import {convertFalsyToHyphen} from "../../constants/base";

function useSchemaMonitoringMarket() {
    const {t} = useTranslation();
    const locale = useSelector((state) => state.language.locale);

    /**
     * 테이블 헤더에 표시할 항목 문자열 배열
     */
    const headerKeys = [
        "날짜",
        "등록 수량",
        "최저 등록 금액",
        "최고 등록 금액",
        "평균 등록 금액",
        "거래 수량",
        "총 거래 금액",
        "평균 거래 금액",
        "총 거래 수수료"
    ];

    /**
     * 서버로부터 전달받은 request를 테이블에 표시할 내용으로 변환한다.
     *
     * 오브젝트 키는 param1, param10 등의 형식으로 param 다음에 숫자를 붙여서 사용한다.
     *
     * param1은 헤더의 첫번째 표시되는 항목이다.
     *
     * 헤더에는 표시되지 않지만 상세에 표시될 항목의 경우 headSize 이후의 숫자를 사용한다.
     *
     * key는 반드시 있어야 한다.
     * @param {object} row
     * @returns
     */
    const parse = (row) => {

        const id = row?.index;
        // const date = row?.date;
        // const registerAverageAmount = row?.registerAverageAmount;
        // const registerCount = row?.registerCount;
        // const registerMaxPrice = changeNumApi.div18(row?.registerMaxPrice);



        // // 등록
        const registerCount = row?.registerCount || 0;
        const minPrice = parseFloat(convertBigNumToDecimalString(row?.registerMinPrice, 3)) || 0;
        const maxPrice = parseFloat(convertBigNumToDecimalString(row?.registerMaxPrice, 3)) || 0;
        const registerTotalPrice = parseFloat(convertBigNumToDecimalString(row?.registerTotalPrice, 3)) || 0;
        const registerAveragePrice = (registerTotalPrice / registerCount) || 0;
        //
        // // 거래
        const transactionCount = row?.transactionCount || 0;
        const transactionTotalPrice = parseFloat(convertBigNumToDecimalString(row?.transactionTotalPrice, 3)) || 0;
        const transactionAveragePrice = (transactionTotalPrice / transactionCount) || 0;
        const transactionTotalFee = parseFloat(convertBigNumToDecimalString(row?.transactionTotalFee, 3)) || 0;
        const newDate = timeFormAPI.changeDataDate(row?.targetDate);

        return {
            key: id, // 키는 반드시 있어야 한다.
            param1: newDate,
            param2: convertFalsyToHyphen((registerCount || 0).toLocaleString()),
            param3: convertFalsyToHyphen((minPrice || 0).toLocaleString()),
            param4: convertFalsyToHyphen((maxPrice || 0).toLocaleString()),
            param5: convertFalsyToHyphen(Number(registerAveragePrice.toFixed(3) || 0).toLocaleString()),
            param6: convertFalsyToHyphen(transactionCount),
            param7: convertFalsyToHyphen((transactionTotalPrice || 0).toLocaleString()),
            param8: convertFalsyToHyphen(Number(transactionAveragePrice.toFixed(3) || 0).toLocaleString()),
            param9: convertFalsyToHyphen(transactionTotalFee),
        };
    };



    /**
     * 로그 데이터를 클릭했을 때 보여줄 디테일 다이얼로그에 보여줄 항목을 작성한다.
     *
     * 입력값인 row는 위의 parse에서 변환된 값이다.
     *
     * @param {object} row
     * @returns
     */
    const details = (row) => {
        const array = [];
        if (row) {
            //
        }
        return array;
    };

    const [schema, setSchema] = useState();

    useEffect(() => {
        const headers = headerKeys.map((key) => t(key));
        const schema = create({
            heads: headers,
            parseFunc: parse,
            detailFunc: details,
        });
        setSchema(schema);
    }, [locale]);

    return schema;
}

export default useSchemaMonitoringMarket;
